// Full product detail content, keyed by slug.
// Content translated precisely from the source material, kept 1:1 with no

export const productDetails = {
  "avery-dennison-reflective-sheeting": {
    title: "Avery Dennison Reflective Films",
    brand: "Avery Dennison",
    category: "Reflective Sheeting",
    gallery: [
      "/images/products/avery-dennison-reflective-sheeting/reflective-sheeting.jpg",
      "/images/products/avery-dennison-reflective-sheeting/2.jpeg",
      "/images/products/avery-dennison-reflective-sheeting/3.jpeg",
       "/images/products/avery-dennison-reflective-sheeting/4.jpeg",
      "/images/products/avery-dennison-reflective-sheeting/5.jpeg",
       "/images/products/avery-dennison-reflective-sheeting/6.jpeg",
      "/images/products/avery-dennison-reflective-sheeting/7.jpeg",
    ],
    tagline: "American-made reflective film for every type of road sign",
    description: [
      "This reflective film is American-made, produced by Avery Dennison — the leading US manufacturer of reflective films.",
    ],
    features: [
      "High reflectivity, making it easy to see from a distance both day and night",
      "Very strong adhesion, making it difficult to remove from aluminum sign panels",
      "Long service life with a high-grade warranty",
      "Easy to install on all kinds of angles and shapes",
      "Resistant to varying weather conditions — sun, rain, wind and sandstorms",
      "A removable protective layer that can be written on and peeled away easily, extending the sign's service life",
      "Can be printed using both digital printing and screen printing",
      "Compliant with the international ASTM D4956 standard",
    ],
    specs: [
      {
        label: "Available Colors",
        value: "White, Yellow, Blue, Green, Red, Brown, Fluorescent, Orange",
      },
      { label: "Standard", value: "ASTM D4956" },
      { label: "Printing", value: "Digital printing and screen printing" },
      { label: "T-1500", value: "ASTM D4956-19 Type I — Class RA1" },
      { label: "T-2500", value: "ASTM D4956-19 Type II — Class RA1" },
      { label: "T-6500 (High Intensity Prismatic)", value: "ASTM D4956-19 Type III/IV — Class RA2" },
      { label: "T-11500 (Omnicube)", value: "ASTM D4956-19 Type XI — Class RA3" },
      { label: "V-6700B (Conspicuity Tape)", value: "Class C 104R-000001 — ECE Compliant" },
      { label: "V-8000 (Prismatic Vehicle Film)", value: "NFPA 1901 — UK Police HOSDB" },
      { label: "OL-1000 (Anti-Graffiti Laminate)", value: "Protective laminate for sign faces" },
    ],
    usages: [
      "Overhead guide signs (gantry and cantilever) — lettering and backgrounds",
      "Guide, directional and warning signs, and street name signs",
      "All types of traffic safety signs",
      "Indoor and advertising signs",
      "Any sign type regardless of size, shape or category",
      "Can be written on using digital printing machines and screen printing",
      "Printing of logos and brand marks",
    ],
    standards: ["ASTM D4956"],
  },

  "reflective-conspicuity-tape": {
    title: "Reflective Conspicuity Tape for Trucks and Trailers",
    brand: "Avery Dennison",
    category: "Truck & Trailer Marking",
    gallery: [
      "/images/products/reflective-sheeting/1.jpeg",
      "/images/products/reflective-sheeting/2.jpeg",
      "/images/products/reflective-sheeting/saso-2913.jpeg",
      "/images/products/reflective-sheeting/4.jpeg",
    ],
    tagline: "High-visibility tape for trucks and trailers",
    description: [
      "We at Road's Reflectors Trading Est. are the exclusive agent for Avery Dennison, the leading American manufacturer of reflective sheeting.",
      "This American-made tape for truck and trailer barriers is known for its high-quality reflectivity and adhesion. It is fitted to the side barriers and the front and rear bumpers of trucks and trailers, making vehicles easier to see at night.",
    ],
    usages: [
      "Mounted on the side, front and rear barriers of trucks, trailers and other vehicles for easier night-time visibility and to help avoid collisions",
    ],
    features: [
      "American-made",
      "Genuine Avery Dennison brand",
      "8-year warranty",
      "Approved by traffic authorities, periodic vehicle inspection, and the Saudi Standards, Metrology and Quality Organization",
      "High brightness",
      "Easy to cut and install on the barrier",
      "Resistant to varying weather conditions",
      "Compliant with ECE 104 and SASO 2913 standards",
      "Provides exceptional visibility at all distances at dawn and at night",
      "Low-temperature adhesive that allows application in cold weather conditions",
      "Available in multiple colors",
      "Roll length: 50 meters",
    ],
    specs: [
      { label: "Product Code", value: "V-6700B" },
      { label: "Classification", value: "Class C 104R-000001, ECE Compliant" },
      { label: "Approved Colors", value: "Yellow, White, Red" },
      { label: "Available Widths", value: "2\" (5 cm), 3\" (7.5 cm), 4\" (10 cm)" },
      { label: "Roll Length", value: "50 m" },
      { label: "Warranty", value: "8 years" },
    ],
    standards: ["ECE 104", "SASO 2913"],
  },

  "solar-cats-eyes": {
    title: "Solar-Powered Cat's Eyes",
    brand: "Road's Reflectors",
    category: "Road Studs",
    gallery: [
      "/images/products/solar-cats-eyes/1.jpg",
      "/images/products/solar-cats-eyes/2.jpeg",
      "/images/products/solar-cats-eyes/3.jpeg",
      "/images/products/solar-cats-eyes/4.jpeg",
    ],
    tagline: "Solar-powered road studs for night-time lane marking",
    description: [
      "Solar-powered cat's eyes are a type of ground road marker. They are manufactured to convert solar energy through solar panels throughout the day and store it in an internal battery, then begin lighting automatically at sunset until the following sunrise, repeating the cycle every day.",
      "They suit a modern, developed appearance and help save energy since they run on renewable power.",
      "Their lighting defines lane paths at night, giving roads an attractive appearance after dark. They are available in several sizes and colors on request, including versions suitable for tunnels.",
    ],
    usages: [
      "On highways and main and secondary roads",
      "City entrances and exits",
      "At curves and bends",
      "Tunnel entrances, exits and interiors",
      "Street entrances and exits",
    ],
    specs: [
      { label: "Body Material", value: "Aluminum" },
      { label: "Lighting Type", value: "LED" },
      { label: "Sizes & Colors", value: "Available in multiple sizes and colors" },
    ],
  },

  "sma-crash-cushions": {
    title: "SMA Crash Cushions",
    brand: "SMA",
    category: "Crash Cushions",
    gallery: [
      "/images/products/sma-crash-cushions/sma-crash-cushion.jpg",
      "/images/products/sma-crash-cushions/2.jpeg",
    ],
    tagline: "Italian-made impact attenuation for hazardous road sections",
    description: [
      "These crash cushions are Italian-made and work to provide the necessary protection for drivers of light and heavy vehicles against injury or vehicle damage.",
      "They are produced in different sizes, dimensions and speed ratings to match the speed of roads inside and outside cities and on highways.",
    ],
    usages: [
      "Junctions and intersections of main and secondary roads",
      "At checkpoints",
      "Highway exits and city entrances",
      "The start and end of concrete barriers",
      "The start of bridges and tunnels, and road forks",
    ],
    features: [
      "Quick and easy installation on asphalt",
      "High capability to absorb impact",
      "Easy to maintain after a collision",
      "High impact-absorption capability that helps preserve drivers' lives",
      "Italian-made",
      "Approved by the Ministry of Transport",
      "Available in multiple shapes and lengths to suit all street and road designs",
      "All parts manufactured from steel",
      "Compact size suitable for tunnels and small, narrow spaces",
    ],
    specs: [
      { label: "Available Speed Ratings", value: "50 km/h, 80 km/h, 100 km/h, 110 km/h" },
    ],
  },

  "rayolite-marker-road-studs": {
    title: "Rayolite Marker Reflective Plastic Road Markers",
    brand: "Rayolite",
    category: "Road Markers",
    gallery: [
      "/images/products/rayolite-marker.jpg",
      "/images/products/rayolite-marker-road-studs/1.jpeg",
      "/images/products/rayolite-marker-road-studs/2.jpeg",
    ],
    tagline: "American-made reflective plastic road markers",
    description: [
      "Plastic road markers are one type of road marking aimed at defining road lanes and side boundaries to organize vehicle traffic. When driven over they generate noise that alerts drowsy drivers who cross the road boundary or move between lanes.",
      "They are installed ahead of speed bumps, reflecting vehicle headlights to make the bumps clearly visible at night.",
    ],
    specs: [
      { label: "Material", value: "Plastic / Acrylic, which aids load-bearing strength" },
      { label: "Available Colors", value: "White, Yellow, Red, Blue" },
      { label: "Size", value: "10 cm × 10 cm" },
      { label: "Lens Type", value: "AA Standard Reflector / AA-ARC Long-Life Reflector" },
      { label: "AA Material", value: "True Cube-Corner reflex reflector, optical-grade Methyl Methacrylate (Plastic)" },
      { label: "AA-ARC Material", value: "Optical-grade Methyl Methacrylate filled with adherent thermosetting compound, plus abrasion-resistance coating" },
      { label: "Reflective Area", value: "3.25 sq. in (21 sq. cm)" },
      { label: "Reflector Dimensions", value: "4\" × 4\" × 0.680\" (10 cm × 10 cm × 1.7 cm)" },
    ],
    usages: [
      "Parking lots",
      "Roads and areas that require lane definition",
      "Main highways, secondary roads and within residential neighborhoods",
      "Installed ahead of speed bumps so they reflect vehicle light and let drivers see the bumps",
      "Marking highway entrances and exits",
      "Ahead of checkpoints, to help slow traffic",
    ],
    features: [
      "Made of plastic over acrylic, which prevents water, dust and dirt from getting inside and helps it bear heavy loads",
      "American-made",
      "Long service life exceeding 3 years in field projects",
      "High reflectivity that aids visibility at night and during the day",
      "High resistance to heavy loads",
      "Fitted with a rough underside layer that helps it adhere firmly to the ground once epoxy is applied and it is fixed to the road",
      "Rib and fish-hook design for maximum adherence between the shell and fill material",
      "AA-ARC variant includes an abrasion-resistance coating chemically bonded to the lens to protect it from the grinding action of dirt, sand and traffic",
      "Both AA and AA-ARC variants offer maximum strength, high reflectivity and maximum shell-to-fill adherence",
    ],
  },

  "scorpion-truck-mounted-attenuators": {
    title: "Scorpion Truck-Mounted Attenuators",
    brand: "TrafFix Devices",
    category: "Truck-Mounted Attenuators",
    gallery: [
      "/images/products/scorpion-truck-mounted-attenuators/1.jpeg",
      "/images/products/scorpion-truck-mounted-attenuators/3.jpeg",
    ],
    tagline: "American-made mobile crash cushions mounted on trucks",
    description: [
      "The Scorpion-type truck-mounted crash cushions are American-made, produced by TrafFix Devices, a leading American company in road safety equipment and tools.",
      "It is a mobile crash cushion mounted on the rear of the support vehicle's frame to absorb impact and reduce its effect, preserving lives and reducing material losses.",
      "The Scorpion II TMA is the world's first MASH Tested, Passed, and Eligible Truck Mounted Attenuator. It is hydraulically powered and ideal for stationary and mobile construction zones.",
    ],
    usages: [
      "Used in highway works and maintenance",
      "Mounted on the rear of the truck to protect it from potential collisions",
      "Fitted to the vehicle and used during various road works — road maintenance, installing and maintaining road signs, and maintaining road poles",
      "Used on moving shadow trucks, stationary block vehicles, or advanced warning vehicles upstream of a moving or stationary operation",
    ],
    features: [
      "High capability to absorb impact",
      "Easy to maintain after a collision",
      "High impact-absorption capability that helps preserve drivers' lives",
      "American-made",
      "Approved by the Ministry of Transport",
      "Compliant with the American MASH test standards",
      "All parts manufactured from steel",
      "World's first MASH Tested, Passed, and Eligible Truck Mounted Attenuator",
      "Hydraulically powered for both stationary and mobile operations",
      "Equipped with LED brake, directional and running lights for enhanced advance warning to drivers",
      "No upper support-vehicle weight limit (infinite weight)",
    ],
    specs: [
      { label: "Available Speed Ratings", value: "70 km/h, 100 km/h" },
      { label: "Scorpion Metro TL-2 Plus", value: "50 mph (80 kph)" },
      { label: "Scorpion II (MASH TL-3)", value: "62.5 mph (100 kph)" },
      { label: "Minimum Support Vehicle Weight", value: "15,000 lbs (6,804 kg), no upper weight limit" },
      { label: "Lighting", value: "LED brake, directional and running lights" },
    ],
    standards: ["MASH Test", "MASH TL-3"],
  },

  "delta-grx-retroreflectometer": {
    title: "Delta GRX Reflective Sheeting Measuring Device",
    brand: "Delta (Denmark)",
    category: "Measuring Instruments",
    gallery: [
      "/images/products/delta-grx-retroreflectometer/delta-grx.jpg",
      "/images/products/delta-grx-retroreflectometer/1.jpeg",
      "/images/products/delta-grx-retroreflectometer/2.jpeg",
    ],
    tagline: "Handheld retroreflectivity meter for road sign sheeting",
    description: [
      "Road's Reflectors Trading Est. is the exclusive agent in the Kingdom of Saudi Arabia for Delta of Denmark, the leading manufacturer of retroreflectivity measuring instruments.",
    ],
    usages: [
      "The Delta GRX reflectivity device is used to measure the reflectivity of the reflective sheeting used on road signs",
    ],
    features: [
      "Danish-made device",
      "Provides both daytime and night-time readings",
      "Features a high-brightness color touchscreen",
      "Automatic recognition of the reflector color",
      "Logs all reading data — time, date and location of the reading",
      "2-million-reading device memory, with a USB port to add backup memory",
      "Supports location services and WiFi",
      "All measuring devices can be linked to a single computer to view and track all results",
      "Fast-charging battery — charges in a short 45-minute period",
      "A single battery charge is sufficient for 700 to 800 readings",
      "Measures up to 7 readings in a single session",
      "Single measurement time: 1 second",
      "Stored data can be transferred to a computer via USB",
      "Built-in camera for imaging the sign, for easy calibration, scanning, and detecting the correct measurement direction",
      "Comes with a carrying case containing the device, 2 batteries, a battery charger, the calibration piece, and a tool for measuring and determining the entrance angle to make reflectivity measurement easier",
      "2-year warranty",
    ],
    specs: [
      { label: "Memory", value: "2,000,000 readings + USB backup memory" },
      { label: "Battery Life", value: "700–800 readings per charge" },
      { label: "Charge Time", value: "45 minutes" },
      { label: "Readings per Session", value: "Up to 7" },
      { label: "Measurement Time", value: "1 second" },
      { label: "Warranty", value: "2 years" },
    ],
  },

  "ltl-3500-retroreflectometer": {
    title: "LTL 3500 Paint Reflectivity Measuring Device",
    brand: "Delta (Denmark)",
    category: "Measuring Instruments",
    gallery: [
      "/images/products/ltl-3500-retroreflectometer/ltl-3500.jpg",
      "/images/products/ltl-3500-retroreflectometer/1.jpeg",
    ],
    tagline: "Precision measurement of road-marking paint reflectivity",
    description: [
      "Road's Reflectors Trading Est. is the exclusive agent in the Kingdom of Saudi Arabia for Delta of Denmark, the leading manufacturer of retroreflectivity measuring instruments.",
    ],
    usages: [
      "The device is used to measure the reflectivity of road-marking paint",
    ],
    features: [
      "Made in Denmark",
      "Provides RL & QD daytime and night-time readings",
      "Features an LED color touchscreen",
      "Logs all reading data — time, date, location of the reading, outdoor temperature, and humidity",
      "8 GB of memory, sufficient to store 2 million readings, plus a port for backup flash memory",
      "Supports location services and WiFi",
      "All measuring devices can be linked to a single computer to view and track all results",
      "Fast-charging battery — charges in a short 45-minute period",
      "A single battery charge is sufficient for 700 to 800 readings",
      "Single measurement time: 1 second",
      "Comes with a calibration tool to make calibrating the device easier",
      "Stored data can be transferred to a computer via flash memory, and it can also connect to a printer to print out the results",
      "Built-in camera for imaging the sign, for easy calibration, scanning, and detecting the correct measurement direction",
      "Comes with a lightweight carrying case containing the device, 2 batteries, a battery charger, and the calibration piece",
      "2-year warranty",
    ],
    specs: [
      { label: "Memory", value: "8 GB (~2,000,000 readings) + flash backup" },
      { label: "Battery Life", value: "700–800 readings per charge" },
      { label: "Charge Time", value: "45 minutes" },
      { label: "Measurement Time", value: "1 second" },
      { label: "Warranty", value: "2 years" },
    ],
  },

  "flexible-delineator-posts": {
    title: "Flexible Delineator Posts",
    brand: "TrafFix Devices",
    category: "Delineators",
    gallery: [
      "/images/products/flexible-delineator-posts/delineator-posts.jpg",
      "/images/products/flexible-delineator-posts/1.jpeg",
      "/images/products/flexible-delineator-posts/2.jpeg",
      "/images/products/flexible-delineator-posts/3.jpeg",
      "/images/products/flexible-delineator-posts/4.jpeg",
    ],
    tagline: "Reboundable posts that spring back after impact",
    description: [
      "Flexible plastic delineator posts, American-made by TrafFix Devices — a leader in road-safety products. They guide vehicles along the road, and their flexibility reduces damage from impact.",
      "The Reboundable Delineator is an economical, surface-mounted post made from UV-resistant polyethylene, providing 180° to 360° reflectivity.",
    ],
    usages: [
      "Defining road paths and dividing them into lanes or branch-road exits",
      "Marking parking areas",
      "Indicating road edges and hazardous exits",
      "Installed ahead of crash cushions as an early warning",
      "Installed before checkpoints",
      "Marking highway exits as a lane-path indicator",
    ],
    features: [
      "High flexibility — returns to its original position after impact",
      "High impact resistance",
      "American-made to high specifications",
      "Fitted with a reflective strip for easy night-time visibility",
      "Resistant to weather conditions (sun, rain, wind)",
      "Fitted with genuine Avery Dennison reflectors, 12-year warranty",
      "Available in multiple lengths and shapes",
      "Posts attach to a flexible Urethane base for high-speed applications, or an ABS plastic base for lower-speed applications",
      "Can be secured with SuperBundy adhesive pads, 2.5\" concrete bolts, or 4\" asphalt bolts",
      "MASH Tested, Passed, and Eligible",
      "Economical, surface-mounted design made from UV-resistant polyethylene",
    ],
    specs: [
      { label: "Reflector Warranty", value: "12 years" },
      { label: "Reflectivity", value: "180° – 360°" },
    ],
    standards: ["MASH Test"],
  },

  "traffix-channelizer-drum": {
    title: "TrafFix Channelizer Drum™",
    brand: "TrafFix Devices",
    category: "Delineators",
    gallery: [
      "/images/products/channelizer-drum-1.jpg",
      "/images/products/channelizer-drum-2.jpg",
      "/images/products/channelizer-drum-3.jpg",
    ],
    tagline: "Durable, interchangeable work-zone channelizer drums since 1987",
    description: [
      "TrafFix Channelizer Drums are available in rugged, durable high-density polyethylene, or impact-resistant, reshapeable low-density polyethylene.",
      "Since 1987, TrafFix Devices, Inc. has provided their customers the most value for their channelizer drum dollars. The drum tops and bases made in 1987 are still interchangeable with the current production model.",
    ],
    usages: [
      "Channelizing traffic through work zones",
      "Marking lane closures and detours",
      "Delineating hazards on roads and highways",
    ],
    features: [
      "Available in rugged, durable high-density polyethylene, or impact-resistant, reshapeable low-density polyethylene",
      "Drum tops and bases interchangeable across decades of production",
      "Multiple base options available: Recycled Rubber, Sand Bag, San-Fil, and Tire Ring bases",
    ],
    specs: [
      { label: "Material Options", value: "High-density polyethylene (rugged/durable) or low-density polyethylene (impact-resistant, reshapeable)" },
      { label: "Base Options", value: "Recycled Rubber, Sand Bag, San-Fil, Tire Ring" },
    ],
  },

  "delta-crash-cushion": {
    title: "Delta™ Crash Cushion",
    brand: "TrafFix Devices / Delta",
    category: "Crash Cushions",
    gallery: [
      "/images/products/delta-crash-cushion-1.jpg",
      "/images/products/delta-crash-cushion-2.jpg",
      "/images/products/delta-crash-cushion-3.jpg",
    ],
    tagline: "Simple, significantly safe steel fender-panel crash cushion",
    description: [
      "The Delta Crash Cushion consists of a series of steel three-beam fender panels supported by steel diaphragms. It attenuates energy evenly for all vehicle types, with shear bolts allowing tearing through cut-outs of various sizes and shapes.",
      "Quick and easy installation reduces exposure to traffic. The multi-directional object marker comes in Chevron, Left or Right angles, and can be quickly changed in the field.",
      "It performs in all temperatures and climates and is a low-cost, MASH TL-3 non-gating redirective crash cushion, co-developed with Delta / MORSE.",
    ],
    usages: [
      "Shielding hazardous fixed objects on roads and highways",
      "Junctions, intersections and the start and end of concrete barriers",
      "Highway construction and maintenance zones",
    ],
    features: [
      "Series of steel three-beam fender panels supported by steel diaphragms",
      "Attenuates energy evenly for all vehicle types",
      "Shear bolts allow controlled tearing through cut-outs of various sizes and shapes",
      "Quick and easy installation reduces exposure to traffic",
      "Multi-directional object marker available in Chevron, Left or Right orientations, quickly changed in the field",
      "Performs in all temperatures and climates",
      "Low-cost, MASH TL-3 non-gating redirective crash cushion",
      "Co-developed with Delta / MORSE",
      "MASH Tested, Passed, and Eligible",
    ],
    specs: [
      { label: "Panel Sizes", value: "1N, 2N, 3N, 4.5N, 5N" },
      { label: "Test Level", value: "MASH TL-3" },
      { label: "Cushion Type", value: "Non-gating, redirective" },
    ],
    standards: ["MASH TL-3"],
  },

  "traffix-sled-crash-cushion": {
    title: "TrafFix SLED® (Sentry Longitudinal Energy Dissipater)",
    brand: "TrafFix Devices",
    category: "Crash Cushions",
    gallery: [
      "/images/products/traffix-sled-1.jpg",
      "/images/products/traffix-sled-2.jpg",
      "/images/products/traffix-sled-3.jpg",
    ],
    tagline: "Narrow, water-filled crash cushion for barrier ends",
    description: [
      "The Sentry Longitudinal Energy Dissipater (SLED) is a narrow, water-filled, non-redirective gating crash cushion.",
      "It is designed to shield the end of permanent and temporary portable barriers, including those made of concrete, steel and plastic.",
    ],
    usages: [
      "Shielding the ends of permanent concrete barriers",
      "Shielding the ends of temporary and portable barriers made of concrete, steel or plastic",
      "Highway construction and maintenance zones",
    ],
    features: [
      "Narrow profile suited to tight sites",
      "Water-filled, non-redirective, gating design",
      "Shields the end of permanent and temporary portable barriers",
      "MASH Tested, Passed, and Eligible",
    ],
    specs: [
      { label: "Cushion Type", value: "Non-redirective, gating" },
      { label: "Fill", value: "Water" },
      { label: "Compatible Barriers", value: "Concrete, steel and plastic" },
    ],
    standards: ["MASH Test"],
  },

  "vermac-vehicle-mounted-arrowboards": {
    title: "Ver-Mac Vehicle-Mounted Arrowboards (VM 4815 / VM 4825)",
    brand: "Ver-Mac",
    category: "Arrow Boards",
    gallery: [
      "/images/products/vermac-arrowboard-1.jpg",
      "/images/products/vermac-arrowboard-2.jpg",
      "/images/products/vermac-arrowboard-3.jpg",
    ],
    tagline: "LED vehicle-mounted arrowboards with Optibright Technology",
    description: [
      "Road's Reflectors Trading Est. supplies mobile electronic traffic control and lighting/security equipment — including variable message signs, arrow boards, speed feedback signs, temporary traffic signals, speed sensors and light towers — to improve the safety and mobility of workers and motorists.",
      "The VM 4815 and VM 4825 are vehicle-mounted arrowboards built with Optibright Technology for high-visibility LED displays.",
    ],
    usages: [
      "Mounted on work vehicles to direct traffic around lane closures and mobile operations",
      "Highway maintenance and construction work zones",
    ],
    features: [
      "VM 4815: 15 LED lamps with Optibright Technology",
      "VM 4825: 25 LED lamps with Optibright Technology",
      "Vehicle-mounted for mobile and stationary work-zone operations",
    ],
    specs: [
      { label: "VM 4815 Lamps", value: "15 LED lamps, Optibright Technology" },
      { label: "VM 4825 Lamps", value: "25 LED lamps, Optibright Technology" },
    ],
  },

  "vermac-variable-message-boards": {
    title: "Ver-Mac Variable Message Boards (PCMS-320RT / PCMS-320 H4D)",
    brand: "Ver-Mac",
    category: "Variable Message Signs",
    gallery: [
      "/images/products/vermac-pcms-1.jpg",
      "/images/products/vermac-pcms-2.jpg",
      "/images/products/vermac-pcms-3.jpg",
    ],
    tagline: "Trailer-mounted changeable message signs with full-color displays",
    description: [
      "The PCMS-320RT is a trailer-mounted variable message board using Rainbow Technology, capable of displaying 16,000 colors.",
      "The PCMS-320 H4D is a compact, trailer-mounted, portable changeable message sign.",
    ],
    usages: [
      "Displaying real-time traffic advisories and warnings",
      "Directing traffic around construction and maintenance zones",
      "Temporary and mobile traffic-management operations",
    ],
    features: [
      "PCMS-320RT: Rainbow Technology display with 16,000 colors",
      "PCMS-320 H4D: portable, trailer-mounted, compact changeable message sign",
    ],
    specs: [
      { label: "PCMS-320RT Display", value: "Rainbow Technology — 16,000 colors" },
      { label: "PCMS-320RT Mount", value: "Trailer-mounted" },
      { label: "PCMS-320 H4D Format", value: "Trailer-mounted, portable changeable message sign" },
    ],
  },

  "vermac-solar-light-tower": {
    title: "Ver-Mac PSLT-4000s Solar-Powered Light Tower",
    brand: "Ver-Mac",
    category: "Lighting & Security Equipment",
    gallery: [
      "/images/products/vermac-light-tower-1.jpg",
      "/images/products/vermac-light-tower-2.jpg",
      "/images/products/vermac-light-tower-3.jpg",
    ],
    tagline: "Solar-powered light tower with adjustable Nightbrite LED lighting",
    description: [
      "The PSLT-4000s is a solar-powered light tower using Nightbrite Technology to provide reliable illumination for work zones without a grid power connection.",
    ],
    usages: [
      "Illuminating work zones and construction sites at night",
      "Mobile and remote-site lighting where grid power is unavailable",
    ],
    features: [
      "Solar-powered — no external power source required",
      "Nightbrite Technology with 4 adjustable LED lights",
      "Suitable for remote and mobile work-zone lighting",
    ],
    specs: [
      { label: "Power Source", value: "Solar" },
      { label: "Lighting", value: "Nightbrite Technology, 4 adjustable LED lights" },
    ],
  },

  "traffic-bollards": {
    title: "Traffic Bollards",
    brand: "Road's Reflectors",
    category: "Bollards",
    gallery: [
      "/images/products/traffic-bollards-1.jpg",
      "/images/products/traffic-bollards-2.jpg",
      "/images/products/traffic-bollards-3.jpg",
    ],
    tagline: "Flexible bollards for lane separation and directional guidance",
    description: [
      "Traffic bollards are used to physically and visually separate traffic lanes, protect pedestrians, and guide vehicles around hazards or restricted areas.",
    ],
    usages: [
      "Lane separation on roads and in parking areas",
      "Marking pedestrian zones and building entrances",
      "Directional guidance at medians and channelized intersections",
    ],
    features: [
      "Available in solid colors and directional-arrow designs",
      "Durable, weather-resistant construction",
      "Easy to install and relocate as needed",
    ],
    specs: [
      { label: "Available Types", value: "Standard bollard, Directional-arrow bollard" },
    ],
  },

  "ceramic-road-markers": {
    title: "Ceramic Road Markers",
    brand: "Road's Reflectors",
    category: "Road Markers",
    gallery: [
      "/images/products/ceramic-road-markers-1.jpg",
      "/images/products/ceramic-road-markers-2.jpg",
      "/images/products/ceramic-road-markers-3.jpg",
    ],
    tagline: "Ceramic pavement markers in 4-inch and 6-inch reflective sizes",
    description: [
      "Ceramic road markers are ground-mounted markers used to define lanes and road boundaries. They are available in a 4-inch size and a 6-inch size fitted with a reflector for enhanced night-time visibility.",
    ],
    usages: [
      "Lane and boundary definition on roads and highways",
      "Marking curves, intersections and pedestrian crossings",
    ],
    features: [
      "Available in 4-inch and 6-inch sizes",
      "6-inch version fitted with a reflector for night-time visibility",
      "Durable ceramic construction resistant to traffic wear",
    ],
    specs: [
      { label: "Sizes", value: "4\" and 6\" (6\" fitted with reflector)" },
    ],
  },

  "solar-sunflower": {
    title: "Solar Sunflower Road Marker",
    brand: "Road's Reflectors",
    category: "Road Studs",
    gallery: [
      "/images/products/solar-sunflower-1.jpg",
      "/images/products/solar-sunflower-2.jpg",
      "/images/products/solar-sunflower-3.jpg",
    ],
    tagline: "Solar-powered, multi-LED road marker for 360° visibility",
    description: [
      "The Solar Sunflower is a solar-powered road marker fitted with multiple LEDs arranged in a circular pattern to provide all-round visibility at night.",
    ],
    usages: [
      "Roundabouts and traffic islands",
      "Curves, intersections and hazard points requiring 360° visibility",
      "Highways and main roads",
    ],
    features: [
      "Solar-powered with automatic dusk-to-dawn operation",
      "Multiple LEDs arranged for 360° visibility",
      "Weather-resistant, low-maintenance design",
    ],
    specs: [
      { label: "Power Source", value: "Solar" },
      { label: "Lighting Pattern", value: "360° multi-LED array" },
    ],
  },

  "traffic-cones": {
    title: "Traffic Cones",
    brand: "Road's Reflectors",
    category: "Channelization",
    gallery: [
      "/images/products/traffic-cones-1.jpg",
      "/images/products/traffic-cones-2.jpg",
      "/images/products/traffic-cones-3.jpg",
    ],
    tagline: "Reflective PVC traffic cones for temporary work-zone channelization",
    description: [
      "Traffic cones are used to temporarily channelize traffic, mark hazards, and delineate work areas on roads and in parking facilities.",
    ],
    usages: [
      "Temporary lane closures and work zones",
      "Marking hazards and obstructions",
      "Parking areas and event traffic control",
    ],
    features: [
      "Reflective collar for night-time visibility",
      "Lightweight, stackable PVC construction",
      "Weighted base for stability",
    ],
    specs: [
      { label: "Material", value: "PVC" },
    ],
  },
}